// extracted by mini-css-extract-plugin
module.exports = {"root":"PriceFilterPopup_root__26ZDl","label":"PriceFilterPopup_label__g7ucx","labelSelected":"PriceFilterPopup_labelSelected___5C0I"};